const errorsMap = {
  asset_payload_is_too_large: 'error.sb.assets.upload_size',
  project_info_get_error: 'error.sb.projectInfo.get_info',
  project_info_update_error: 'error.sb.projectInfo.update_info',
  project_info_toggle_component_error: 'error.sb.projectInfo.toggle_component'
};

export default errorsMap;
